import { PlatformAdminZone } from '@skylabs-digital/react-identity-access';
import { Outlet } from 'react-router-dom';

/**
 * La guarda de las rutas de adentro: el contexto `(platform, admin)`.
 * `LoginPage` evalúa EL MISMO preset por nombre (`platformAdmin`), así el
 * rebote entre `/login` y `/` es imposible por construcción.
 */
export function ProtectedRoute() {
  return (
    <PlatformAdminZone
      redirectTo="/login"
      loadingFallback={() => (
        <div className="flex h-screen items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
        </div>
      )}
    >
      <Outlet />
    </PlatformAdminZone>
  );
}
